import React, { useState } from 'react';
import styled from 'styled-components';
import { FiFile } from 'react-icons/fi';
import { AiOutlineDelete } from "react-icons/ai";
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";
import { AcceptFileFormat } from './acceptFileFormat';

const Container = styled.div`
    display: ${props => props.inline ? 'flex' : ''};
    align-items: center;
    margin: 10px 0;
`;

const Title = styled.p`
    margin: 0 10px 0 0;
    font-weight: 600;
    color: #121180;
`;

const FileLabel = styled.label`
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    opacity: ${props => props.disabled ? 0.6 : 1};
    padding: 8px 15px;
    border: 1px solid #121180;
    border-radius: 5px;
    font-size: 14px;
    background: #fff;
    margin-right: 15px;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    :hover{
        border: ${props => props.disabled ? '' : '2px solid #121180'};
    }
`;

const Upload = ({
    loading, isArabic, formID, previewFile, label, arabiclabel, onChange, selectedFiles, name, selectedFilesContent, 
    placeholder, arabicplaceholder, required, inline, multiple, documentvault, documentFromVault, listDocument, 
    category, accept, handleRemoveDocument, uploadFileErr, disabled, error
}) => {
    const [showDocuments, setShowDocuments] = useState(false);
    let fileName = (selectedFiles && selectedFiles.length > 10) ? selectedFiles.slice(0, 10) + '..' : selectedFiles;
    placeholder = (placeholder && placeholder.length > 10) ? placeholder.slice(0, 10) + '..' : placeholder;
    arabicplaceholder = (arabicplaceholder && arabicplaceholder.length > 10) ? arabicplaceholder.slice(0, 10) + '..' : arabicplaceholder;
    return(
        <div className={"d-flex align-items-end col-12 p-0 " + (isArabic ? 'arabic' : '')}>
            <Container inline={inline} className="col-11 p-0">
                {label && <Title className={isArabic ? 'arabic' : ''}>{isArabic ? arabiclabel : label} {required && <span style={{color: 'red', marginLeft: '2px'}}>*</span>}{!formID && category && category.label && <span className="badge badge-info mx-2" style={{display: 'inline', borderRadius: '3px', padding: '5px 10px'}}>{isArabic ? category.arabiclabel : category.label}</span>}</Title>}
                <div className="d-flex justify-content-start">
                    <div className="d-flex align-items-center col-6 p-0" style={{marginTop: '8px'}}>
                        <FileLabel htmlFor={label} disabled={disabled}>
                            {loading ? <Loader type="Oval" color="#2d207d" height={20} width={20} style={{marginLeft: '10px'}} /> :
                                ((!documentFromVault && selectedFiles) ? fileName : ((placeholder && placeholder.length > 0) ? (isArabic ? arabicplaceholder : placeholder) : `${isArabic ? 'اختر ملف' : 'Choose File'}`))}
                        </FileLabel>
                        <input disabled={loading || disabled} accept={AcceptFileFormat} style={{opacity: 0, position: 'absolute', left: 0, right: 0}} type="file" id={label} onChange={onChange} name={label} datamultiplecaption={`${2} files selected`} multiple={multiple} />
                    </div>
                    {documentvault && <div className="col-6 p-0" style={{marginTop: '8px'}} onClick={() => (disabled ? '' : listDocument())}>
                        <FileLabel disabled={disabled}>{(documentFromVault && selectedFiles) ? fileName : (isArabic ? 'مكتبة' : 'Library')}</FileLabel>
                    </div>}
                </div>
                {(uploadFileErr || error) && <p className="text-danger" style={{margin: '5px 0 0 0'}}>{(uploadFileErr || error)}</p>}
            </Container>
            <div className="p-0 col-1 ml-3" style={{position: 'relative', top: ((uploadFileErr || error) ? '-42px' : '-15px')}}>
                {/* {(!documentFromVault && selectedFiles) && <AiOutlineDelete className="cursor-pointer" style={{height: '25px', width: '25px'}} onClick={() => handleRemoveDocument(name, selectedFilesContent)} />} */}
                {(previewFile && previewFile.length !== 0) && <FiFile onClick={() => setShowDocuments(true)} style={{height: '25px', width: '25px'}} />}
            </div>
            {previewFile && showDocuments && <div>
                <div className="modal" style={{display: 'block'}}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Existing Documents</h5>
                                <button type="button" className="close" aria-label="Close" onClick={() => setShowDocuments(false)}>
                                    <MdClose />
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="d-flex align-items-center flex-wrap">
                                    {previewFile.map(({documentId, contentType, fileName, thumbnailUri}) => {
                                        fileName = (fileName && fileName.length > 15) ? fileName.slice(0, 15) + '..' : fileName;
                                        let imgType = fileName && (fileName.includes('png') || fileName.includes('jpeg') || fileName.includes('jpg'));
                                        return (
                                            <div key={documentId} className="document font-weight-bold my-4">
                                                <div style={{width: 'auto', height: '111px', margin: '0 auto'}}>
                                                    {imgType ? <img src={thumbnailUri} alt="Thumbnail" width="100%" height="100%" />
                                                    : <img src={'/Assets/nopreview.png'} alt="Thumbnail" style={{width: '150px', height: 'auto'}} />}
                                                </div>
                                                <div className="position-absolute bottom-0 bg-white d-flex col-12 align-items-center justify-content-lg-between p-3 m-0 w-100">
                                                    <p className="m-0 p-0 col-10">{fileName}</p>
                                                    <AiOutlineDelete className="cursor-pointer col-2 p-0" style={{fontSize: '20px'}} onClick={() => handleRemoveDocument(name, documentId)} />
                                                </div>
                                            </div>
                                        )}
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-light-danger font-weight-bold" onClick={() => setShowDocuments(false)}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show"></div>
            </div>}
        </div>
    );
};

export default Upload;